import React from 'react';
import { Spinner } from './Spinner';

export const UiBlockingSpinner: React.FC<{ isBlocking?: boolean; children?: React.ReactNode; ariaLabel?: string }> = ({
    isBlocking = false,
    children,
    ariaLabel,
}) => {
    return isBlocking ? (
        <Spinner section ariaLabel={ariaLabel}>
            {children}
        </Spinner>
    ) : (
        <>{children}</>
    );
};
